"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentQrCode = void 0;
const qrcode_react_1 = require("qrcode.react");
const react_1 = __importDefault(require("react"));
const buildAnalyticUrl_1 = require("../../../../utils/buildAnalyticUrl");
const PaymentQrCode = (invoice) => {
    const publicPaymentUrl = (0, buildAnalyticUrl_1.buildAnalyticUrl)(invoice.publicPaymentUrl, {
        utmMedium: 'qr-code',
        utmSource: 'pdf',
    });
    return (react_1.default.createElement(qrcode_react_1.QRCodeSVG, { size: 75, value: publicPaymentUrl !== null && publicPaymentUrl !== void 0 ? publicPaymentUrl : 'This link will lead you to the payment page' }));
};
exports.PaymentQrCode = PaymentQrCode;
